// extracted by mini-css-extract-plugin
export default {"section01":"about-page_section01__ffA0d","section02":"about-page_section02__Y-gq6"};